<div
  class="section p-0 pl-2"
  [ngClass]="{ amendment: signature?.pendingChange }"
>
  <div class="row pl-3 pr-3 full-height">
    <div
      class="col-12 col-lg-4 d-flex justify-content-start align-items-center py-2"
    >
      <div class="row no-gutters full-width min-60">
        <div class="col-10 p-0 d-flex align-items-center">
          <h6 class="m-0" [innerHTML]="questionSanitized"></h6>
        </div>

        <div class="col-2 d-flex align-items-center justify-content-end">
          <mat-checkbox
            [(ngModel)]="checked"
            [disabled]="questionDisabled || !!signature?.pendingChange"
            (change)="checkboxChange()"
          >
          </mat-checkbox>
        </div>
        <div class="col-12" *ngIf="checked && checklistTypeID">
          <checklist-status
            [formStatus]="status"
            [checked]="checked"
            [checklistsIDs]="checklistsIDs"
            [checklistTypeID]="checklistTypeID"
            [disabled]="signature?.pendingChange || questionDisabled"
            (changed)="textChanged($event)"
            (changing)="pendingOpApprovalChangesEvent($event)"
            (undoing)="undo()"
            [isChanging]="checkboxChanged"
          >
          </checklist-status>
        </div>
        <div
          class="col-12 small d-flex full-width justify-content-between flex-row"
          [ngClass]="{ 'pending-changes-box': signature?.pendingChange }"
        >
          <div
            class="d-flex full-width align-items-start"
            [ngClass]="{ changes: signature?.pendingChange }"
          >
            <div
              class="white mb-1 align-self-start"
              *ngIf="signature?.pendingChange"
            >
              <h6>Pending Changes:</h6>
            </div>

            <div
              *ngIf="lastChange"
              [ngClass]="{
                inline: checklistChips?.length,
                'd-flex full-width justify-content-between':
                  !checklistChips?.length,
              }"
            >
              <span id="lastChange" [innerHTML]="lastChange"></span>
              <document-chips
                [documentChips]="checklistChips"
                [shadow]="true"
              ></document-chips>
              <span
                class="ml-1"
                id="lastChangeBy"
                [innerHTML]="lastChangeBy"
              ></span
              >&nbsp;
              <span id="lastChangeApproval" [innerHTML]="lastApproval"></span>
            </div>
          </div>
          <span
            class="d-flex c-buttons flex-column justify-content-center align-items-end"
            *ngIf="signature?.pendingChange"
          >
            <button
              mat-mini-fab
              class="undo-button"
              matTooltip="Undo change"
              color="warn"
              *ngIf="answerChangedById && answerChangedById == currentUser?.id"
              (click)="undo()"
            >
              <mat-icon>undo</mat-icon>
            </button>
            <button
              *ngIf="canApproveAnswer"
              mat-flat-button
              class="approval-button mb-1"
              color="primary"
              (click)="apprAns()"
            >
              Approve
            </button>
            <button
              *ngIf="canApproveAnswer"
              mat-flat-button
              class="approval-button"
              color="warn"
              (click)="disapAns()"
            >
              Disapprove
            </button>
          </span>
        </div>
      </div>
    </div>
    <div
      class="col-12 col-lg-5 d-flex flex-column justify-content-center align-items-center background"
    >
      <div
        class="d-flex justify-content-center align-items-center p-2"
        [ngStyle]="{ opacity: checked ? '1' : '0.5' }"
      >
        <h6>
          {{ title }}
        </h6>
        <role-chips [roleCodes]="roleCodes" class="ml-2"></role-chips>
      </div>
      <button
        mat-flat-button
        class="approval-button mb-2 d-print-none"
        *ngIf="visible"
        [disabled]="disabled || signature?.pendingChange || checklistNotClosed"
        [color]="color"
        (click)="click()"
      >
        {{ label }}
      </button>
      <button
        mat-flat-button
        class="approval-button m-2 d-print-none"
        *ngIf="visible && showDisapprove && !disabled"
        [disabled]="disabled"
        color="warn"
        (click)="disap()"
      >
        Disapprove
      </button>
    </div>
    <div class="col-12 col-lg-3 background d-flex align-items-center">
      <div class="row full-width" *ngIf="approved">
        <div class="col-3">By:</div>
        <div class="col-9">
          <span class="name">{{ name || signature?.approvedBy?.name }}</span>
        </div>
        <div class="col-3">Date:</div>
        <div class="col-9">
          <span class="date">{{
            date || signature?.approvedOn | date: "medium"
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
